import { closeMenuDrawer, isOpen } from "@app/components/menu-drawer";
import { createCustomerAccessToken } from "@app/lib/authentication";
import { Error } from "@app/types/misc";
import { authenticationErrorMessage } from "@app/utils/authentication";
import Cookies from "js-cookie";

document.addEventListener("DOMContentLoaded", () => {
  initForm();
  initLoginPageRedirect();

  // Open the login drawer if `?login` is in the URL.
  const params = new URLSearchParams(window.location.search);
  if (params.has("login")) {
    window.history.pushState({}, document.title, "/");
    document.dispatchEvent(new CustomEvent("drawer:login:open"));
  }

  // Register button
  const $registerButton: HTMLButtonElement | null = document.querySelector(".button-register");
  if ($registerButton) {
    $registerButton.addEventListener("click", () => {
      document.dispatchEvent(new CustomEvent("drawer:login:close"));
      document.dispatchEvent(new CustomEvent("drawer:register:open"));
    });
  }

  // Password recover button
  const $passwordRecoverButton: HTMLButtonElement | null = document.querySelector(".button-forgot-password");
  if ($passwordRecoverButton) {
    $passwordRecoverButton.addEventListener("click", () => {
      document.dispatchEvent(new CustomEvent("drawer:login:close"));
      document.dispatchEvent(new CustomEvent("drawer:password-recover:open"));
    });
  }
});

const initForm = () => {
  const $form: HTMLFormElement | null = document.querySelector(".form-login #customer_login");
  if (!$form) return;

  const $submitButton: HTMLButtonElement | null = $form.querySelector("button[type='submit']");
  const $emailInput: HTMLInputElement | null = $form.querySelector("input[name='customer[email]']");
  const $passwordInput: HTMLInputElement | null = $form.querySelector("input[name='customer[password]']");

  if (!$submitButton || !$emailInput || !$passwordInput) return;

  const $emailInputWrapper: HTMLDivElement | null = $emailInput.closest(".snippet-input");
  const $passwordInputWrapper: HTMLDivElement | null = $passwordInput.closest(".snippet-input");

  if (!$emailInputWrapper || !$passwordInputWrapper) return;

  [$emailInput, $passwordInput].forEach(($input) => {
    $input.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        $submitButton.click();
      }
    });
  });

  $form.addEventListener("submit", async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    cleanInputError($emailInputWrapper);
    cleanInputError($passwordInputWrapper);

    const email = $emailInput.value;
    const password = $passwordInput.value;
    $submitButton.disabled = true;
    const error = await submitForm(email, password);

    if (error && error.field !== "password") {
      inputError($emailInputWrapper, error);
    }

    if (error && error.field === "password") {
      inputError($passwordInputWrapper, error);
    }

    if (!error) {
      $form.submit();
    } else {
      $submitButton.disabled = false;
    }
  });

  const $passwordRecoverSuccess = document.querySelector(".password-recover-success");

  document.addEventListener("drawer:login:open", (e: any) => {
    // Display password update success message
    if (Cookies.get("passwordUpdated")) {
      document.querySelector(".password-update-success-message")?.classList.remove("hidden");
      Cookies.remove("passwordUpdated");
    }

    const isPasswordRecover = e.detail?.isPasswordRecover;

    if (isPasswordRecover) {
      $passwordRecoverSuccess?.classList.remove("hidden");
    } else {
      $passwordRecoverSuccess?.classList.add("hidden");
    }

    const prefillEmail = e.detail?.email;
    const prefillPassword = e.detail?.password;
    const triggerSubmit = e.detail?.submit;

    if (prefillEmail) {
      $emailInput.value = prefillEmail;
    }

    if (prefillPassword) {
      $passwordInput.value = prefillPassword;
    }

    if (triggerSubmit) {
      $submitButton.click();
    }
  });
};

const submitForm = async (emailValue: string, passwordValue: string) => {
  const email = (emailValue || "").trim();
  const password = (passwordValue || "").trim();

  let error: Error | null = null;

  if (!email) {
    error = { field: "email", message: "Enter your email" };
    return error;
  }

  if (!password) {
    error = { field: "password", message: "Enter your password" };
    return error;
  }

  const res = await createCustomerAccessToken(email, password);

  if (res.customerUserErrors.length > 0) {
    error = {
      ...res.customerUserErrors[0],
      ...(res.customerUserErrors[0].field && {
        field: res.customerUserErrors[0].field[res.customerUserErrors[0].field.length - 1],
      }),
    };
    return error;
  }
};

const inputError = ($inputWrapper: HTMLDivElement, error: Error) => {
  const $helperText: HTMLDivElement | null = $inputWrapper.querySelector(".helper-text");
  if (!$helperText) return;
  $inputWrapper.classList.add("snippet-input--error");

  let errorMessage = error.message;

  if (error.code && authenticationErrorMessage[error.code]) {
    errorMessage = authenticationErrorMessage[error.code];
  }

  $helperText.innerText = errorMessage;

  $helperText.classList.remove("hidden");
};

const cleanInputError = ($inputWrapper: HTMLDivElement) => {
  const $helperText: HTMLDivElement | null = $inputWrapper.querySelector(".helper-text");
  if (!$helperText) return;
  $inputWrapper.classList.remove("snippet-input--error");
  $helperText.classList.add("hidden");
};

/**
 * Will redirect to the homepage if a user lands on the login page.
 */
const initLoginPageRedirect = () => {
  if (window.location.pathname === "/account/login") {
    window.location.replace(window.customer ? "/account" : "/?login");
  }
};

const handleAccountNavigation = () => {
  if (window.customer) {
    window.location.href = `/account`;
  } else {
    if (isOpen()) closeMenuDrawer();
    document.dispatchEvent(new CustomEvent("drawer:login:open"));
  }
};

document.querySelectorAll("a[href='/account']").forEach(($link) => {
  $link.addEventListener("click", (e) => {
    e.preventDefault();
    handleAccountNavigation();
  });
});

document.querySelector(".header-login-button")?.addEventListener("click", (e) => {
  e.preventDefault();
  handleAccountNavigation();
});
